import React, { useState } from 'react';
import SEO from '../config/SEO';
import { useUser } from '../context/UserContext';
import { Link } from 'react-router-dom';

const ContactUs = () => {

     const { user, userData } = useUser();

     const [formData, setFormData] = useState({ name: '', email: '', message: '' });

     console.log(userData)

     const handleInputChange = (e) => {
          setFormData({ ...formData, [e.target.name]: e.target.value });
     };

     const handleSendEmail = (e) => {
          e.preventDefault();

          const userInfo = `
--- 𝘜𝘴𝘦𝘳 𝘐𝘯𝘧𝘰 ---
𝘌𝘢𝘳𝘯𝘪𝘯𝘨𝘴: ${userData?.totalEarnings || 'N/A'}
𝘕𝘢𝘮𝘦: ${userData?.name || 'N/A'}
𝘜𝘴𝘦𝘳𝘯𝘢𝘮𝘦:  ${userData?.username || 'N/A'}
𝘌𝘮𝘢𝘪𝘭: ${userData?.email || 'N/A'}
𝘨𝘦𝘯𝘦𝘳𝘢𝘵𝘪𝘰𝘯_𝘤𝘳𝘦𝘥𝘪𝘵𝘴: ${userData?.generation_credits || 'N/A'}
𝘴𝘶𝘣𝘮𝘪𝘵𝘦𝘥 𝘱𝘳𝘰𝘮𝘱𝘵: ${userData?.prompt || 'N/A'}
𝘗𝘭𝘢𝘯: ${userData?.planDetails?.planTitle || 'Free'}
𝘜𝘐𝘋: ${userData?.uid || 'N/A'}
𝘞𝘦𝘣𝘴𝘪𝘵𝘦: ${userData?.website || 'N/A'}
-----------------
  `;

          const subject = "Support Request: " + (userData?.uid || "User");

          const body = `Hi Thedc,\n\nI hope this finds you well!\n\n${formData.message}\n\n${userInfo}\n\nBest regards,\n${formData.name}`;

          const mailtoLink = `https://mail.google.com/mail/u/0/?fs=1&to=thedc.here@gmail.com&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}&tf=cm`;

          // Popup settings
          const width = 600, height = 700;
          const left = window.screen.width / 2 - width / 2;
          const top = window.screen.height / 2 - height / 2;

          window.open(mailtoLink, 'GmailCompose', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`);
     };


     return (

          <>

               <SEO
                    title="Contact Us | HeyPrompt AI Support & Inquiries"
                    description="Have questions about HeyPrompt? Reach out to our team for support, partnership opportunities, or feedback on our AI prompt library."
                    keywords="contact heyprompt, ai prompt support, help with chatgpt prompts, contact us, prompt engineering assistance, heyprompt feedback"
                    canonicalPath="/contact-us"
               />

               <div className="contact-page">
                    <section className="hero">
                         <h1>Let's Talk</h1>
                         <p>We're here to help you build better prompts.</p>
                    </section>

                    <section className="main-content">
                         <div className="contact-grid">
                              <div className="info-side">
                                   <h2>Reach out directly</h2>
                                   <p>For urgent queries, support, or feedback, you can contact us at any time.</p>
                                   <div className="contact-item">
                                        <strong>Support:</strong> thedc.here@gmail.com
                                   </div>
                                   <div className="contact-item">
                                        <strong>Active Account on Instagram:</strong> heyprompt.online
                                   </div>
                              </div>

                              <form className="contact-form" onSubmit={handleSendEmail}>
                                   <input
                                        type="text" name="name" placeholder="Name" required
                                        onChange={handleInputChange}
                                   />
                                   <input
                                        type="email" name="email" placeholder="Email" required
                                        onChange={handleInputChange}
                                   />
                                   <textarea
                                        name="message" placeholder="Briefly describe your issue..." rows="6" required
                                        onChange={handleInputChange}
                                   ></textarea>
                                   {user ?
                                        <button className='btn-submit' type="submit">Send Message</button>
                                        :

                                        <Link className='btn-submit' to="/login">Login Now</Link>
                                   }

                              </form>
                         </div>
                    </section>
               </div>

          </>

     );
};

export default ContactUs;